export default __webpack_public_path__ + "static/media/0271.acc245f4.jpg";